import moment from "moment";

export const generateYearOptions = (startYear = 2024) => {
  const currentYear = moment().year();
  const years = [];

  for (let year = currentYear; year >= startYear; year--) {
    years.push({
      label: `${year}`,
      value: moment({ year }).startOf("year").format("DD-MM-YYYY")
    });
  }

  return years;
};
